const MODERATOR_TOKEN = 'MODERATOR_TOKEN'
const SCHOOL_USER_TOKEN = 'SCHOOL_USER_TOKEN'
const SCHOOL_USER = 'SCHOOL_USER'
const TEST_MOBILE = 'TEST_MOBILE'
const Ishuzedu_lang = 'Ishuzedu_lang';

export function getSchoolToken() {
    return localStorage.getItem(SCHOOL_USER_TOKEN);
}

export function setSchoolToken(token) {
    return localStorage.setItem(SCHOOL_USER_TOKEN, token);
}

export function removeSchoolToken() {
    return localStorage.removeItem(SCHOOL_USER_TOKEN)
}

export function setUserData(data) {
    return localStorage.setItem(SCHOOL_USER, data);
}

export function getUserData() {
    return localStorage.getItem(SCHOOL_USER);
}

export function removeUserData() {
    return localStorage.removeItem(SCHOOL_USER);
}

export function getModeratorToken() {
    return localStorage.getItem(MODERATOR_TOKEN);
}

export function setModeratorToken(token) {
    return localStorage.setItem(MODERATOR_TOKEN, token);
}

export function removeModeratorToken() {
    return localStorage.removeItem(MODERATOR_TOKEN)
}

export function setTestMobile(data) {
    return localStorage.setItem(TEST_MOBILE,data);
}

export function getTestMobile() {
    return localStorage.getItem(TEST_MOBILE)
}

export function removeTestMobile() {
    return localStorage.removeItem(TEST_MOBILE)
}

export function setUserLang(locale) {
    return localStorage.setItem(Ishuzedu_lang, locale);
}
export function getUserLang(){
    return localStorage.getItem(Ishuzedu_lang)
}

export function getSideBarLabel() {
    let user = JSON.parse(localStorage.getItem(SCHOOL_USER));
    if(user) {
        return user.director ? user.director + " \n"+user.organizationshortname : user.name;
    }
    else {
        return "";
    }
}
